import { render, staticRenderFns } from "./mailing-list.vue?vue&type=template&id=1a61bf34"
import script from "./mailing-list.vue?vue&type=script&lang=js"
export * from "./mailing-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports